// extracted by mini-css-extract-plugin
export default {"container":"QuestionItem_container__rdrg2"};